import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=4f39ee94&scoped=true"
import script from "./FolderItem.vue?vue&type=script&lang=js"
export * from "./FolderItem.vue?vue&type=script&lang=js"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=4f39ee94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f39ee94",
  null
  
)

export default component.exports